<div class="alert alert-warning" *ngIf="errors && errors.length">
    <div *ngFor="let item of errors;let i=index;">
        <sync-error-display [errorItem]="item"></sync-error-display>
    </div>
</div>